var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointerLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9938 10.5458L1.6568 0.0660097C1.05692 -0.182434 0.401786 0.306925 0.51229 0.924269L5.06664 26.928C5.18504 27.6131 6.10853 27.8315 6.55055 27.2743L12.4941 19.7458C12.8256 19.3317 13.4807 19.3242 13.8122 19.7307L21.7291 29.3899C22.2974 30.0825 23.3393 30.203 24.0655 29.6609L25.3757 28.6822C26.1019 28.1401 26.2282 27.1464 25.6599 26.4537L17.7115 16.7569C17.3721 16.3428 17.5378 15.733 18.0509 15.5373L26.9859 11.9988C27.6647 11.7278 27.6726 10.8168 27.0017 10.5383L26.9938 10.5458Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerLarge);
export default __webpack_public_path__ + "static/media/pointer-large.826ffa0cc79b722ba0d33de88259f804.svg";
export { ForwardRef as ReactComponent };